import script from "./SliderArea.vue?vue&type=script&setup=true&lang=js"
export * from "./SliderArea.vue?vue&type=script&setup=true&lang=js"

import "./SliderArea.vue?vue&type=style&index=0&id=efbb019a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efbb019a"]])

export default __exports__